<div class="grid-1-auto app-space-right_0_25">
  <!--Auftrag-->
  <ng-container>
    <h5>{{getGlobal('Case')}} {{data?.auNr}}</h5>
    <div>
      <em class="typo-right typo-small">
        {{enumSvc.getEnumerationText(data.au_enmName_AuftragTyp,
        data.au_enmIdent_AuftragTyp)}}
      </em>
      <em class="typo-right typo-small">
        {{enumSvc.getEnumerationText(data.au_enmName_AuftragStatus,
        data.au_enmIdent_AuftragStatus)}}
      </em>
    </div>
  </ng-container>
</div>
<div class="typo-container-s-s-q grid typo-small">
  <!--Mandant-->
  <h6 class="span-layout subheader">Mandant</h6>
  <ng-container>
    <!--Auftraggeber-->
    <ng-container *ngIf="getOEByID(data.au_oeID_Auftraggeber) as OE">
      <span class="typo-small">{{enumSvc.getFieldCaption("Auftrag", "au_oeID_Auftraggeber")}}</span>
      <span>
        <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
      </span>
      <q></q>
    </ng-container>
    <!--Ansprechpartner-->
    <ng-container *ngIf="getOEByID(data.au_oeId_Ansprechpartner) as OE">
      <span class="typo-small">{{enumSvc.getFieldCaption("Auftrag",
        "au_oeId_Ansprechpartner")}}</span>
      <span>
        <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
      </span>
      <q></q>
    </ng-container>
    <!--Mandant OKZ-->
    <ng-container *ngIf="data.auMdtOKZ && data.auMdtOKZ?.length > 0">
      <span class="typo-small">{{enumSvc.getFieldCaption("Auftrag", "auMdtOKZ")}}</span>
      <span>{{data.auMdtOKZ}}</span>
      <q></q>
    </ng-container>
  </ng-container>
  <!-- Versicherung -->
  <h6 class="span-layout subheader">Versicherung</h6>
  <ng-container>
    <!-- Versicherungsnehmer -->
    <ng-container *ngIf="getOEByID(data.aue_oeID_VN) as OE">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_VN")}}</span>
      <span>
        <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
      </span>
      <q></q>
    </ng-container>
    <!-- Versicherungsnummer -->
    <ng-container *ngIf="data.auOKZ && data.auOKZ.length > 0">
      <span class="typo-small">{{enumSvc.getFieldCaption("Auftrag", "auOKZ")}}</span>
      <span>{{data.auOKZ}}</span>
      <q></q>
    </ng-container>
    <!-- Versicherung-->
    <ng-container *ngIf="getOEByID(data.aue_oeID_Versicherung) as OE">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
        "aue_oeID_Versicherung")}}</span>
      <span>
        <ng-container *ngIf="data.aue_oeID_Versicherung === data.au_oeID_Auftraggeber">
         <span class="typo-small">identisch mit Auftraggeber</span>
        </ng-container>
        <ng-container *ngIf="data.aue_oeID_Versicherung !== data.au_oeID_Auftraggeber">
          <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
        </ng-container>
      </span>
      <q></q>
    </ng-container>
    <!-- Ansprechpartner -->
    <ng-container *ngIf="getOEByID(data.aue_oeID_Versicherung_AnspPtnr) as OE">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
        "aue_oeID_Versicherung_AnspPtnr")}}
      </span>
      <span>
        <ng-container
          *ngIf="data.aue_oeID_Versicherung_AnspPtnr === data.au_oeId_Ansprechpartner">
          <span class="typo-small">identisch mit Auftraggeber</span>
        </ng-container>
        <ng-container
          *ngIf="data.aue_oeID_Versicherung_AnspPtnr !== data.au_oeId_Ansprechpartner">
          <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
         </ng-container>
      </span>
      <q></q>
    </ng-container>
    <!-- Versicherungsart-->
    <ng-container *ngIf="data.aue_enmIdent_Versicherungsart !== 0">
                        <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
                          "aue_enmIdent_Versicherungsart")}}</span>
      <span>{{enumSvc.getEnumerationText(data.aue_enmName_Versicherungsart,
        data.aue_enmIdent_Versicherungsart)}}</span>
      <q></q>
    </ng-container>
    <!-- Versicherungssumme-->
    <ng-container>
      <div class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueVersicherungSumme")}}</div>
      <div class="span-2 typo-right">{{data.aueVersicherungSumme | excCurrency: '€'}}</div>
    </ng-container>
    <!-- Wert1914-->
    <ng-container>
      <div class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueWert1914")}}</div>
      <div class="span-2 typo-right">{{data.aueWert1914 | excCurrency: '€'}}</div>
    </ng-container>
    <!-- Selbstbehalt-->
    <ng-container>
      <div class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSelbstbehalt")}}</div>
      <div class="span-2 typo-right">{{data.aueSelbstbehalt | excCurrency: '€'}}</div>
    </ng-container>
    <!-- aueHinweiseEntschaedigungsgrenze-->
    <ng-container>
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueHinweiseEntschaedigungsgrenze")}}</span>
      <span class="span-2 typo-left">{{data.aueHinweiseEntschaedigungsgrenze}}</span>
    </ng-container>
    <!-- ReserveVU-->
    <ng-container>
      <div class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserveVU")}}</div>
      <div class="span-2 typo-right">{{data.aueReserveVU | excCurrency: '€'}}</div>
    </ng-container>
    <!-- ReserveEXCON-->
    <ng-container>
      <div class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserve")}}</div>
      <div class="span-2 typo-right">{{data.aueReserve | excCurrency: '€'}}</div>
    </ng-container>
    <!-- Schadensumme-->
    <ng-container>
      <div class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadensumme")}}</div>
      <div class="span-2 typo-right">{{data.aueSchadensumme | excCurrency: '€'}}</div>
    </ng-container>
    <!-- Regulierungssumme-->
    <ng-container>
      <div class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueRegulierungsumme")}}</div>
      <div class="span-2 typo-right">{{data.aueRegulierungsumme | excCurrency: '€'}}</div>
    </ng-container>
    <!-- Einsparbetrag-->
    <ng-container>
      <div class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueEinsparbetrag")}}</div>
      <div class="span-2 typo-right">{{data.aueEinsparbetrag | excCurrency: '€'}}</div>
    </ng-container>
    <!-- Leistungsgegenstand-->
    <ng-container *ngIf="data.aueLeistungsgegenstand">
                        <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
                          "aueLeistungsgegenstand")}}</span>
      <span><ng-container *ngFor="let v of data.aueLeistungsgegenstand.split('||')">
        <ul><li>{{enumSvc.getEnumerationText('Leistungsgegenstand', v.replaceAll('|', ''))}}</li></ul>
      </ng-container></span>
      <q></q>
    </ng-container>
    <!-- Regressmöglichkeit-->
    <ng-container *ngIf="data.aueRegressmoeglichkeit_enmIdent && data.aueRegressmoeglichkeit_enmIdent !== 0">
                        <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
                          "aueRegressmoeglichkeit_enmIdent")}}</span>
      <span>{{enumSvc.getEnumerationText(data.aueRegressmoeglichkeit_enmName,
        data.aueRegressmoeglichkeit_enmIdent)}}</span>
      <q></q>
    </ng-container>
  </ng-container>
  <!-- Auftragdetails -->
  <h6 class="span-layout subheader">Auftragsdetails</h6>
  <ng-container>
    <!-- Schadennummer -->
    <ng-container *ngIf="data.aueSchadenNr && data.aueSchadenNr.length > 0">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenNr")}}</span>
      <span>{{data.aueSchadenNr}}</span>
      <q></q>
    </ng-container>
    <!-- Schadendatum -->
    <ng-container *ngIf="data.aueSchadenDatum">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenDatum")}}</span>
      <span>{{data.aueSchadenDatum | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- Schadenmeldung VU -->
    <ng-container *ngIf="data.aueSchadenmeldungVU">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenmeldungVU")}}</span>
      <span>{{data.aueSchadenmeldungVU | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- Schadenart -->
    <ng-container *ngIf="data.aue_enmIdent_SchadenArt !== 0">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
        "aue_enmIdent_SchadenArt")}}</span>
      <span>
	      <strong>
		      {{enumSvc.getEnumerationTextA(
	              data.aue_enmName_SchadenArt,
	              data.aue_enmIdent_SchadenArt)}}  ({{
	          enumSvc.getEnumerationText(
	              data.aue_enmName_SchadenArt,
	              data.aue_enmIdent_SchadenArt
	          )
		      }})
		      </strong>
      </span>
      <q></q>
    </ng-container>
    <!-- Schadenursache -->
    <ng-container *ngIf="data.aue_enmIdent_SchadenUrsache !== 0">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
        "aue_enmIdent_SchadenUrsache")}}</span>
      <span>{{enumSvc.getEnumerationText(
        data.aue_enmName_SchadenUrsache,
        data.aue_enmIdent_SchadenUrsache)}}</span>
      <q></q>
    </ng-container>
    <!-- Schadenort -->
    <ng-container>
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenOrt")}}</span>
      <span>
        <ng-container *ngIf="Schadenort as address">
        <em>{{address.adrStr}} {{address.adrHNum}} </em>
        <em>{{address.adrPlz}} {{address.adrOrt}}</em>
      </ng-container>
        <br/>
      </span>
      <q></q>

    </ng-container>
    <!-- Ansprechpartner -->
    <ng-container *ngIf="getOEByID(data.aue_oeID_AnspPtnr) as OE">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_AnspPtnr")}}</span>
      <span>
       <ng-container
         *ngIf="data.aue_oeID_VN === data.aue_oeID_AnspPtnr">
         <span class="typo-small">identisch mit Versicherungsnehmer</span>
       </ng-container>
       <ng-container
         *ngIf="data.aue_oeID_VN !== data.aue_oeID_AnspPtnr">
          <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
       </ng-container>
      </span>
      <q></q>
    </ng-container>
    <!-- Auftragsbeschreibung -->
    <ng-container *ngIf="data.auBeschreibung !== ''">
      <span class="typo-small">{{enumSvc.getFieldCaption("Auftrag",
      "auBeschreibung")}}</span>
      <span>{{data.auBeschreibung}}</span>
      <q></q>
    </ng-container>
    <!-- Anspruchsteller -->
    <ng-container *ngIf="getOEByID(data.aue_oeID_Anspruchsteller) as OE">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
        "aueAnspruchsteller")}}</span>
      <span>
        <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
      </span>
      <q></q>
    </ng-container>
    <!-- Weitere Ansprechpartner-->
    <ng-container *ngIf="getOEByID(data.aue_oeID_WAnsprPtnr1) as OE">
      <span class="typo-small">{{enumSvc.getEnumerationText(
        data.aue_enmName_WAnsprPtnrFunktion,
        data.aue_enmIdent_WAnsprPtnr1Funktion)
        }}: </span>
      <span>
        <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
      </span>
      <q></q>
    </ng-container>
    <ng-container *ngIf="getOEByID(data.aue_oeID_WAnsprPtnr2) as OE">
      <span class="typo-small">{{enumSvc.getEnumerationText(
        data.aue_enmName_WAnsprPtnrFunktion,
        data.aue_enmIdent_WAnsprPtnr2Funktion)
        }}: </span>
      <span>
        <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
      </span>
      <q></q>
    </ng-container>
    <ng-container *ngIf="getOEByID(data.aue_oeID_WAnsprPtnr3) as OE">
      <span class="typo-small">
        {{enumSvc.getEnumerationText(
        data.aue_enmName_WAnsprPtnrFunktion,
        data.aue_enmIdent_WAnsprPtnr3Funktion)}}:
      </span>
      <span>
        <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
      </span>
      <q></q>
    </ng-container>
    <ng-container *ngIf="getOEByID(data.aue_oeID_WAnsprPtnr4) as OE">
       <span class="typo-small">{{enumSvc.getEnumerationText(
         data.aue_enmName_WAnsprPtnrFunktion,
         data.aue_enmIdent_WAnsprPtnr4Funktion)
         }}: </span>
      <span>
       <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
      </span>
      <q></q>
    </ng-container>
  </ng-container>
  <!-- Auftragsablauf -->
  <h6 class="span-layout subheader">Auftragsablauf</h6>
  <ng-container>
    <!-- Auftragsdatum -->
    <ng-container *ngIf="data.aueAuftragsdatum">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAuftragsdatum")}}</span>
      <span>{{data.aueAuftragsdatum | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- Ortstermin geplant -->
    <ng-container *ngIf="data.aueOrtsterminPlan">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtsterminPlan")}}</span>
      <span>{{data.aueOrtsterminPlan | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- Kontaktaufnahme -->
    <ng-container *ngIf="data.aueKontaktaufnahme">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueKontaktaufnahme")}}</span>
      <span>{{data.aueKontaktaufnahme | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- Kontaktaufnahmeversuche -->
    <ng-container *ngIf="data.aueKontaktaufnahmeVersuche != '[]' && data.aueKontaktaufnahmeVersuche">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueKontaktaufnahmeVersuche")}}</span>
      <span>
       <ng-container *ngFor="let attempt of getKontaktaufnahmeVersucheArray(data.aueKontaktaufnahmeVersuche)">
        {{attempt.date || attempt}}<ng-container *ngIf="attempt.comment"> {{attempt.comment}}</ng-container><br/>
      </ng-container>
      </span>
      <q></q>
    </ng-container>
    <!-- Ortstermin -->
    <ng-container *ngIf="data.aueOrtstermin">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin")}}</span>
      <span>{{data.aueOrtstermin | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- 2. Ortstermin -->
    <ng-container *ngIf="data.aueOrtstermin2">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin2")}}</span>
      <span>{{data.aueOrtstermin2 | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- Weitere Ortstermine -->
    <ng-container *ngIf="data.aueWeitereOrtstermine">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueWeitereOrtstermine")}}</span>
      <span>{{data.aueWeitereOrtstermine}}</span>
      <q></q>
    </ng-container>
    <!-- Fristverlängerung -->
    <ng-container *ngIf="!data.aueFristverlaengerungBis">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueFristverlaengerungBis")}}</span>
      <span></span>
      <q></q>
    </ng-container>
    <ng-container *ngIf="data.aueFristverlaengerungBis">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueFristverlaengerungBis")}}</span>
      <span>{{data.aueFristverlaengerungBis | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- Reklamation -->
    <ng-container *ngIf="data.aueReklamation_enmIdent && data.aueReklamation_enmIdent !== 0">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
        "aueReklamation_enmIdent")}}</span>
      <span>{{enumSvc.getEnumerationText(
        data.aueReklamation_enmName,
        data.aueReklamation_enmIdent)}}</span>
      <q></q>
    </ng-container>
    <!-- Datum Zwischenbericht -->
    <ng-container *ngIf="data.aueZwischenberichtDatum">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueZwischenberichtDatum")}}</span>
      <span>{{data.aueZwischenberichtDatum | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- Abschlussdatum -->
    <ng-container *ngIf="data.aueAbschlussdatum">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAbschlussdatum")}}</span>
      <span>{{data.aueAbschlussdatum | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- Abrechnungshinweis -->
    <ng-container *ngIf="data.aueAbrechnungshinweis_enmIdent && data.aueAbrechnungshinweis_enmIdent !== 0">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
        "aueAbrechnungshinweis_enmIdent")}}</span>
      <span>{{enumSvc.getEnumerationText(
        data.aueAbrechnungshinweis_enmName,
        data.aueAbrechnungshinweis_enmIdent)}}</span>
      <q></q>
    </ng-container>
    <!-- Detail -->
    <ng-container *ngIf="data.aueAbrechnungshinweisSub1_enmIdent  && data.aueAbrechnungshinweisSub1_enmIdent !== 0">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
        "aueAbrechnungshinweisSub1_enmIdent")}}</span>
      <span>{{enumSvc.getEnumerationText(
        data.aueAbrechnungshinweisSub1_enmName,
        data.aueAbrechnungshinweisSub1_enmIdent)}}</span>
      <q></q>
    </ng-container>
    <!-- Belegprüfung Inklusiv bis -->
    <ng-container *ngIf="data.aueAbrechnungshinweisDatum && data.aueAbrechnungshinweis_enmIdent === 1">
      <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAbrechnungshinweisDatum")}}</span>
      <span>{{data.aueAbrechnungshinweisDatum | excDate}}</span>
      <q></q>
    </ng-container>
    <!-- letzter Sachverständiger -->
    <ng-container *ngIf="getOEByID(data.aue_oeID_letzterSachverstaendiger) as OE">
    <span class="typo-small">
      {{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterSachverstaendiger")}}
    </span>
      <span>
     <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
    </span>
      <q></q>
    </ng-container>
    <!-- letzter Sanierungspartner -->
    <ng-container *ngIf="getOEByID(data.aue_oeID_letzterSanierungspartner) as OE">
    <span class="typo-small">{{enumSvc.getFieldCaption("AuftragE_EIS",
      "aueLetzterSanierungspartner")}}
    </span>
      <span>
     <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"></app-organization-unit-box-view>
    </span>
      <q></q>
    </ng-container>
  </ng-container>
</div>
